'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'heart-half-stroke';
var width = 512;
var height = 512;
var aliases = ["heart-half-alt"];
var unicode = 'e1ac';
var svgPathData = 'M241.5 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.3 9.4-27.5 14.1-43.1 14.1s-30.8-4.7-43.1-14.1l0 0C140.4 410.2 .5 279.9 .5 167.7l0-2.6C.5 91.6 60.1 32 133.6 32 176.3 32 216.5 52.5 241.5 87.1zm15 328.9c2.9 0 4.1-.8 4.2-.9 33.8-25.8 83.1-69 123.3-117.8 42.3-51.4 64.5-97.1 64.5-129.6l0-2.6c0-38.2-30.9-69.1-69.1-69.1-22.2 0-43 10.6-56 28.6-29.8 41.2-52.1 72-66.9 92.4l0 198.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeartHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;